import { GET_ENC, POST_ENC } from "../common/EncryptedHttp";
import { BASE_URL } from "../common/const";

const BASE = `${BASE_URL}/api/OpthalPosteriorSegmentFundus`;

// Vitreous
export const GetVitreousList = (params: any) =>
  GET_ENC(`${BASE}/GetVitreousList?` + params, null);

export const GetVitreousDetail = (params: any) =>
  GET_ENC(`${BASE}/GetVitreousDetail?` + params, null);

export const CreateVitreous = (data: any) =>
  POST_ENC(`${BASE}/CreateVitreous`, data);

export const UpdateVitreous = (data: any) =>
  POST_ENC(`${BASE}/UpdateVitreous`, data);

export const DeleteVitreous = (data: any) =>
  POST_ENC(`${BASE}/DeleteVitreous`, data);

//Optic Disc
export const GetOpticDiscList = (params: any) =>
  GET_ENC(`${BASE}/GetOpticDiscList?` + params, null);

export const GetOpticDiscDetail = (params: any) =>
  GET_ENC(`${BASE}/GetOpticDiscDetail?` + params, null);

export const CreateOpticDisc = (data: any) =>
  POST_ENC(`${BASE}/CreateOpticDisc`, data);

export const UpdateOpticDisc = (data: any) =>
  POST_ENC(`${BASE}/UpdateOpticDisc`, data);

export const DeleteOpticDisc = (data: any) =>
  POST_ENC(`${BASE}/DeleteOpticDisc`, data);


// Cup-to-Disc Ratio
export const GetCupToDiscRatioList = (params: any) =>
  GET_ENC(`${BASE}/GetCupToDiscRatioList?` + params, null);

export const GetCupToDiscRatioDetail = (params: any) =>
  GET_ENC(`${BASE}/GetCupToDiscRatioDetail?` + params, null);

export const CreateCupToDiscRatio = (data: any) =>
  POST_ENC(`${BASE}/CreateCupToDiscRatio`, data);

export const UpdateCupToDiscRatio = (data: any) =>
  POST_ENC(`${BASE}/UpdateCupToDiscRatio`, data);

export const DeleteCupToDiscRatio = (data: any) =>
  POST_ENC(`${BASE}/DeleteCupToDiscRatio`, data);


// Macula
export const GetMaculaList = (params: any) =>
  GET_ENC(`${BASE}/GetMaculaList?` + params, null);

export const GetMaculaDetail = (params: any) =>
  GET_ENC(`${BASE}/GetMaculaDetail?` + params, null);

export const CreateMacula = (data: any) =>
  POST_ENC(`${BASE}/CreateMacula`, data);

export const UpdateMacula = (data: any) =>
  POST_ENC(`${BASE}/UpdateMacula`, data);

export const DeleteMacula = (data: any) =>
  POST_ENC(`${BASE}/DeleteMacula`, data);

// Retinal Vessels
export const GetRetinalVesselsList = (params: any) =>
  GET_ENC(`${BASE}/GetRetinalVesselsList?` + params, null);

export const GetRetinalVesselsDetail = (params: any) =>
  GET_ENC(`${BASE}/GetRetinalVesselsDetail?` + params, null);

export const CreateRetinalVessels = (data: any) =>
  POST_ENC(`${BASE}/CreateRetinalVessels`, data);

export const UpdateRetinalVessels = (data: any) =>
  POST_ENC(`${BASE}/UpdateRetinalVessels`, data);

export const DeleteRetinalVessels = (data: any) =>
  POST_ENC(`${BASE}/DeleteRetinalVessels`, data);

// Peripheral Retina
export const GetPeripheralRetinaList = (params: any) =>
  GET_ENC(`${BASE}/GetPeripheralRetinaList?` + params, null);

export const GetPeripheralRetinaDetail = (params: any) =>
  GET_ENC(`${BASE}/GetPeripheralRetinaDetail?` + params, null);

export const CreatePeripheralRetina = (data: any) =>
  POST_ENC(`${BASE}/CreatePeripheralRetina`, data);

export const UpdatePeripheralRetina = (data: any) =>
  POST_ENC(`${BASE}/UpdatePeripheralRetina`, data);

export const DeletePeripheralRetina = (data: any) =>
  POST_ENC(`${BASE}/DeletePeripheralRetina`, data);